module.exports = __webpack_public_path__ + "static/media/handoff-confirm-m.1dc89ccc.png";